jQuery(function ($) {
	//Load Video Modals and autoplay youtube videos
	let shownVideoModal;

	$(document).on("click", ".mc-image-block-video", function (e) {
		let targetId = e.target.id
			? e.target.id
			: $(this)[0].parentElement.children[0].id;
		shownVideoModal = $("#" + targetId + "modal");
		shownVideoModal.modal("show");
	});

	function createYouTubeIframeVideo(vid, start, cc) {
		let playerVars = { rel: 0 };
		if (start) playerVars.start = start;
		if (cc) playerVars.cc_load_policy = 1;

		return new YT.Player("player-" + vid, {
			videoId: vid,
			playerVars: playerVars,
		});
	}

	let videoList = [];

	function onYouTubePlayerAPIReady() {
		$(".mc-image-block-modal").each(function (i, obj) {
			let _videoObj = $(obj).find(".iframe-video-placeholder");
			let _videoID = _videoObj.data("stripped-id");
			let _videoStart = _videoObj.data("start");
			let _videoCC = _videoObj.data("cc");
			videoList.push({
				_videoID: _videoID,
				_video: createYouTubeIframeVideo(
					_videoID,
					_videoStart,
					_videoCC
				),
			});

			$(obj).on("shown.bs.modal", function (e) {
				$(videoList).each(function (_i, _obj) {
					if (_videoID === _obj["_videoID"]) {
						_obj["_video"].playVideo();
					}
				});
			});

			$(obj).on("hide.bs.modal", function (e) {
				$(videoList).each(function (_i, _obj) {
					if (_videoID === _obj["_videoID"]) {
						_obj["_video"].pauseVideo();
					}
				});
			});
		});
	}

	window.YT.ready(function () {
		onYouTubePlayerAPIReady();
	});
});



// WEBPACK FOOTER //
// ./assets/js/custom.js